import './SelectPlayerPage.scss';
import React, { useEffect, useState }  from 'react';
import { getFantasyPlayers, getFantasyTeams, saveTeam, getUserTeam, saveCapitan, editPlayers, getFantasyConfig } from '../../firebase-service/firebaseService.js'
import PlayerCardMercado from '../../component/PlayerCardMercado.js';
import PlayerCard from '../../component/PlayerCard.js';
import FilterTeam from '../../component/FilterTeam.js';
import { useAuth } from '../../context/authContext'
import { toast } from 'sonner'
import useLongPress from "../../utils/useLongPress.js";
import cara from "../../assets/img/cara-default.png";
import estrella from "../../assets/img/estrella.png";

export function SelectPlayersPage({changeTab}) {

    const [jugadoresFantasy, setJugadoresFantasy] = useState([]);
    const [equiposFantasy, setEquiposFantasy] = useState([]);
    const [selectedPlayers, setSelectedPlayers] = useState([]);
    const [jornada, setJornada] = useState(0);
    const [cambiosAbiertos, setCambiosAbiertos] = useState(true);
    const [configJornadaAnterior, setConfigJornadaAnterior] = useState({capitan:"",sextoHombre:""});
    const [equipoAnterior, setEquipoAnterior] = useState([]);
    
    const [equipoFiltro, setEquipoFiltro] = useState('');

    const [numeroJugadoresEstrella, setNumeroJugadoresEstrella] = useState(6);
    const [numeroJugadoresEstrellaUsados, setNumeroJugadoresEstrellausados] = useState(0);

    const limitSelectedPlayers = 6
    const maxInmaculadaPlayers = 2

    const { currentUser, actualParticipante } = useAuth()

    const config={capitan:"",sextoHombre:""}

    const jugadoresFiltrados = equipoFiltro
        ? jugadoresFantasy.filter((jugador) => jugador.equipo === equipoFiltro)
        : jugadoresFantasy;

    const [openModal, setOpenModal] = useState(false);
    const [selectedPlayerDetail, setSelectedPlayerDetail] = useState(null);

    const isInmaculadaTeam = (equipoNombre = '') => equipoNombre.toUpperCase().includes('INMACULADA');

    const selectedPlayersPreview = Array.from({ length: limitSelectedPlayers }, (_, index) => selectedPlayers[index] || null);
    
    useEffect(() => {
        esperarPorJugadoresFantasy()
        esperarPorEquiposFantasy()
        esperarPorFantasyConfig()
    }, []);

    const handleFiltro = (equipoAFiltrar) => {
        setEquipoFiltro(equipoAFiltrar);
    };

    const esperarPorConfigJornadaAnterior = async (jornada) => {
            if(jornada != 0){
            getUserTeam(currentUser.uid, jornada - 1, resp => {
                if (resp.length > 1) { 
                    setConfigJornadaAnterior(resp[0])
                    setEquipoAnterior(resp)
                }
                if (resp.length <= 1) { setConfigJornadaAnterior({capitan:"",sextoHombre:""}); setEquipoAnterior([]) }
            }, (resp, err) => { console.error(resp, err) })
        }
        };

    const getNumeroJugadoresEstrella = async (jornada) => {
        if(jornada != 1){
            if(actualParticipante.posicionesJornadas[jornada - 2] == -1){
                setNumeroJugadoresEstrella(2)
                console.log("Tienes 2")
            } else {
                setNumeroJugadoresEstrella(1)
                 console.log("Tienes 1")
            }
        }
    };

    const esMismoEquipoQueAnterior = (equipoActual = selectedPlayers) => {
        if (!equipoAnterior || equipoAnterior.length <= 1) return false;

        const nombresActuales = [...equipoActual].map((jugador) => jugador.nombre).sort();
        const nombresAnteriores = [...equipoAnterior].map((jugador) => jugador.nombre).sort();

        return nombresActuales.length === nombresAnteriores.length &&
            nombresActuales.every((nombre, index) => nombre === nombresAnteriores[index]);
    };

    const handleSaveTeam = (equipoAFiltrar) => {
        const inmaculadaPlayersCount = equipoAFiltrar.filter((jugador) => isInmaculadaTeam(jugador.equipo)).length;

        if (inmaculadaPlayersCount !== 2) {
            toast.error('Debes seleccionar exactamente 2 jugadores de Inmaculada antes de guardar')
            return
        }

        if (esMismoEquipoQueAnterior(equipoAFiltrar)) {
            toast.error('No puedes guardar el mismo equipo que la jornada pasada')
            return
        }

        if(equipoAFiltrar[0].nombre == configJornadaAnterior.capitan){
            var j0 = equipoAFiltrar[0]
            var j1 = equipoAFiltrar[1]
            equipoAFiltrar[0] = j1
            equipoAFiltrar[1] = j0
        }
        saveTeam(currentUser.uid, equipoAFiltrar, jornada)
        toast.success('Equipo guardado')
        changeTab()
    };

    const esperarPorJugadoresFantasy = async () => {
        getFantasyPlayers(resp => {
            if (resp.length > 0) { 
                resp.map((p)=>{
                    p.selected = false
                })
                resp.sort((a,b)=> b.puntosJornada[b.puntosJornada.length - 1] - a.puntosJornada[a.puntosJornada.length - 1])
                setJugadoresFantasy(resp)
            }
            if (resp.length === 0) { setJugadoresFantasy([]) }
        }, (resp, err) => { console.error(resp, err) })
    };

    const esperarPorFantasyConfig = async () => {
        getFantasyConfig(resp => {
            if (resp != null) { 
                setJornada(resp.nJornada)
                setCambiosAbiertos(resp.cambiosAbiertos)
                console.log(resp)
                esperarPorConfigJornadaAnterior(resp.nJornada)
                getNumeroJugadoresEstrella(resp.nJornada)
            }
            if (resp === null) { setJornada(0); setCambiosAbiertos(true) }
        }, (resp, err) => { console.error(resp, err) })
    };

    const esperarPorEquiposFantasy = async () => {
        getFantasyTeams(resp => {
            if (resp.length > 0) { 
               setEquiposFantasy(resp)
               console.log(resp)
            }
            if (resp.length === 0) { setEquiposFantasy([]) }
        }, (resp, err) => { console.error(resp, err) })
    };

    const updateSelections = (index) => {
        const jugadoresList = [...jugadoresFiltrados]
        const jugador = jugadoresList[index]
        const isjugadorEstrella = jugador.puntosJornada != null && (jugador.puntosEquipoJornada[jugador.puntosEquipoJornada.length - 1] > 0 || jugador.puntosMvpJornada[jugador.puntosMvpJornada.length - 1] > 0)

        if(!jugador.selected){
            if(selectedPlayers.length >= limitSelectedPlayers){
                return
            }

            const selectedInmaculadaPlayers = selectedPlayers.filter((selected) => isInmaculadaTeam(selected.equipo)).length
            if(isInmaculadaTeam(jugador.equipo) && selectedInmaculadaPlayers >= maxInmaculadaPlayers){
                toast.error('Máximo 2 jugadores de Inmaculada')
                return
            }

            const sameTeamAlreadySelected = selectedPlayers.some((selected) => selected.equipo === jugador.equipo && !isInmaculadaTeam(selected.equipo));
            if(sameTeamAlreadySelected && !isInmaculadaTeam(jugador.equipo)){
                toast.error(`Ya tienes un jugador de ${jugador.equipo} seleccionado`)
                return
            }

            if(!isjugadorEstrella || (isjugadorEstrella && numeroJugadoresEstrellaUsados < numeroJugadoresEstrella)){
                var selectedPlayersTemp = [...selectedPlayers]
                selectedPlayersTemp.push(jugador)
                setSelectedPlayers(selectedPlayersTemp)
                jugador.selected = !jugador.selected
                console.log(selectedPlayersTemp)
                if(isjugadorEstrella){
                    setNumeroJugadoresEstrellausados(numeroJugadoresEstrellaUsados + 1)
                }
            }
        } else{
            var selectedPlayersTemp = [...selectedPlayers]
            selectedPlayersTemp= selectedPlayersTemp.filter((a)=>a.nombre != jugador.nombre)
            setSelectedPlayers(selectedPlayersTemp)
            jugador.selected = !jugador.selected
            if(isjugadorEstrella){
                 setNumeroJugadoresEstrellausados(numeroJugadoresEstrellaUsados - 1)
            }
        }
    };

    const removeSelectedPlayer = (jugador) => {
        if(!jugador) return

        const selectedPlayer = jugadoresFantasy.find((item) => item.nombre === jugador.nombre && item.equipo === jugador.equipo)
        if(selectedPlayer){
            selectedPlayer.selected = false
        }

        setSelectedPlayers((prev) => prev.filter((item) => !(item.nombre === jugador.nombre && item.equipo === jugador.equipo)))

        const isjugadorEstrella = jugador.puntosJornada != null && (jugador.puntosEquipoJornada[jugador.puntosEquipoJornada.length - 1] > 0 || jugador.puntosMvpJornada[jugador.puntosMvpJornada.length - 1] > 0)
        if(isjugadorEstrella){
            setNumeroJugadoresEstrellausados((prev) => Math.max(prev - 1, 0))
        }
    };

    const openDetails = (index) => {
        console.log(currentUser)
        const jugadoresList = [...jugadoresFiltrados]
        setOpenModal(true)
        console.log(jugadoresList[index])
        setSelectedPlayerDetail(jugadoresList[index])
    }

    const cuadriculaPuntos = (jugador) => {
        var rows = []
        for(var i = 0; i< 22; i++){
            var puntos = 0
            //Jornadas aplazadas ejemplo 30
            if(i >= 30){
                puntos += jugador.puntosEquipoJornada[i-1]
                puntos += jugador.puntosJornada[i-1]
                puntos += jugador.puntosMvpJornada[i-1]
            } else {
                puntos += jugador.puntosEquipoJornada[i]
                puntos += jugador.puntosJornada[i]
                puntos += jugador.puntosMvpJornada[i]
            }
            //Jornadas aplazadas ejemplo 30
            if ((puntos.toString() == "NaN") || i == 29){
                rows.push(
                <div className="jornada-container" key={jugador.nombre + jugador.numero + i}>
                    <div className='points'>{"J" + (i+1)}</div>
                </div>);
            } else {
                var isStar = (jugador.puntosEquipoJornada[i] + jugador.puntosMvpJornada[i]) != 0
                rows.push(
                <div className="jornada-container" key={jugador.nombre + jugador.numero + i}>
                    <div className={puntos < 9 ? 'barra-color red' : puntos < 19 ? 'barra-color orange' : puntos < 40 ? 'barra-color green' : 'barra-color gold' } ></div>
                    <div className='points'>{puntos}</div>
                    {isStar &&
                        <img src={estrella} alt="Estrella" className="image-estrella-points" />
                    }
                </div>);
            }
        }
        return rows
    }

    return (
        <main className="select-player-container">
            <div className="team-filter-section">
                <FilterTeam equipos={equiposFantasy} onFilter={handleFiltro} />
            </div>

            <div className="selected-players-summary" aria-label="Jugadores seleccionados">
                {selectedPlayersPreview.map((jugador, index) => (
                    <div key={jugador ? `${jugador.nombre}-${index}` : `slot-${index}`} className={`selected-player-slot ${jugador ? 'filled' : ''}`}>
                        {jugador ? (
                            <>
                                <button
                                    type="button"
                                    className="remove-player-button"
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        removeSelectedPlayer(jugador);
                                    }}
                                    aria-label={`Eliminar ${jugador.nombre}`}
                                >
                                    ×
                                </button>
                                <img src={jugador.escudoClub} alt={jugador.equipo} className="selected-player-team" />
                                <img src={jugador.foto || cara} alt={jugador.nombre} className="selected-player-image" />
                                <span className="selected-player-name">{jugador.nombre.split(' ')[0]}</span>
                            </>
                        ) : (
                            <span className="selected-player-empty">{index + 1}</span>
                        )}
                    </div>
                ))}
            </div>

            {cambiosAbiertos ?
                <div className='jugadores-mercado-container'>
                {jugadoresFiltrados.map((jugador, index) => (
                    <PlayerCardMercado key={index} config={config} index={index} jugador={jugador} updateSelections={updateSelections} longPressActive={true} openDetails={openDetails}/>
                    )) }
                </div>
                : <div className='mercado-text' >MERCADO CERRADO</div>
            }
            {
                selectedPlayers.length == limitSelectedPlayers &&
                <div className='bottom-container' >
                    <div className='button-container' onClick={()=>handleSaveTeam(selectedPlayers)}>
                        <div className='save-button'>
                            Guardar
                        </div>
                    </div>
                </div>
            }

            {openModal &&
                <div className='modal-container-detail'>
                    {selectedPlayerDetail != null &&
                        <>
                            <div className='user-name-text'>
                                {selectedPlayerDetail.nombre}
                            </div>
                            <div className='close-modal' onClick={()=>setOpenModal(false)}>
                                X
                            </div>
                            <div className='data-container-modal'>
                                <div className='images'>
                                    <div className='player-image'>
                                        <img src={selectedPlayerDetail.foto != "" ? selectedPlayerDetail.foto : cara} alt="Cara" className="player-face" />
                                    </div>
                                    
                                    <div className="escudo-container">
                                        <img src={selectedPlayerDetail.escudoClub} alt="Escudo" className="player-team" />
                                    </div>
                                </div>
                                <div className='data-text-modal'>
                                    Media : {selectedPlayerDetail.mediaFantasyJornada}
                                </div>
                                <div className='data-text-modal'>
                                    Puntos por jornadas:
                                </div>
                                <div className='points-container-data'>
                                    { cuadriculaPuntos(selectedPlayerDetail) }
                                </div>
                            </div>
                        </>
                    }
                    
                </div>
            }
        </main>
    );
}